// extracted by mini-css-extract-plugin
export var idIndicator = "beers-section-module--id-indicator--9TcIx";
export var wrapper = "beers-section-module--wrapper--WejIs";